import i18n from '../i18n';





export { sort, asc, desc, naturalOrder, reverseOrder }





function sort(array, compareFn, columns) {
    if (!Array.isArray( columns ))
        columns = [columns];
        
    return i18n.then( i => comparator( i, compareFn, ...columns ) )
        .then( cmp => [...array].sort( cmp ) );
}

function asc(arrays, columns) {
    return sort( arrays, naturalOrder, columns );
}

function desc(arrays, columns) {
    return sort( arrays, reverseOrder, columns );
}

function comparator(i, compareFn, ...columns) {
    return (modelA, modelB) =>
        [...columns, 'id']
            .map( column => column === 'id' ? (model => +model.id) : column )
            .map( column => typeof column === 'function'
                ? compareFn( column( modelA ), column( modelB ) )
                : compareFn( get( modelA, column ), get( modelB, column ) ) )
            .filter( value => value !== 0 )
            [0];
}

function naturalOrder(valueA, valueB) {
    if (valueA == null && valueB == null)
        return 0;
    else if (valueB == null)
        return -1;
    else if (valueA == null)
        return 1;
    else if (valueA < valueB)
        return -1;
    else
        return valueB < valueA ? 1 : 0;
}

function reverseOrder(valueA, valueB) {
    return naturalOrder( valueB, valueA );
}

function get(model, dottedProps) {
    const fn = (value, [head, ...tail]) =>
        value == null
            ? null
            : !!head 
                ? fn( value[head], tail )
                : value;

    const [head, ...tail] = dottedProps.split( '.' );
    return fn( model.get ? model.get( head ) : model[head], tail );
}


// WEBPACK FOOTER //
// ./src/js/collection/sort.js